import { useAuth } from '@/hooks/useAuth'
import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

function RequireAdmin({ children }: { children: ReactNode }) {
  const { loggedIn } = useAuth()
  if (!loggedIn) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default RequireAdmin
